import React, {
    ReactText, useContext, FC,
} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {EditableFormTableContext} from 'components/editable-table/model/editable-form-table.context';
import {selectContextRawData} from 'modules/context/context-selector';
import {selectEntityData} from 'modules/data';
import {createActionHandlerForDelete} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {
    AppControlProceduresResultApi,
    useGetIsAppStatisticsConfirmedQuery,
} from 'store/api/app-control-procedures-result/app-control-procedures-result.api';
import {useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';

import {ActionButton} from '../action-button';
import {ActionConfirmModal} from '../action-confirm-modal/action-confirm-modal';
import {DEFAULT_CLEAR_ELEMENT_CONFIRM_TEXT} from '../button-action-delete-tab/constants/button-delete-tab-constants';
import {ITableActionProps} from '../table-action-types';

interface IButtonActionForClearRowsOwnProps extends ITableActionProps {
}

const ButtonActionForClearRowsComponent: FC<IButtonActionForClearRowsOwnProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: IButtonActionForClearRowsOwnProps) => {
    const referenceUrl = meta?.referenceUrl || entityName;
    const {initData} = useContext(EditableFormTableContext);
    const context = useAppSelector(selectContextRawData);

    const {data: isStatisticsConfirmed} = useGetIsAppStatisticsConfirmedQuery(
        {entityName, params: context}, {skip: !entityName},
    );

    const {selectedRowKeys = []} = useSelector((state: TAppState) => (
        selectEntityData(entityName,
            EEntityType.TABLE)(state) || {}
    ) as ITableEntityData);
    const dispatch = useDispatch();
    const actionsForRows = (ids: ReactText[]) => dispatch(
        createActionHandlerForDelete(
            {
                entityName,
                referenceUrl,
                requestType: meta?.requestType || ERequestType.POST,
                itemList: meta?.itemListKey ? {[meta.itemListKey]: ids} : {ids},
            },
        ),
    );
    const handleClear = async () => {
        actionsForRows(selectedRowKeys);
        await dispatch(AppControlProceduresResultApi.util.invalidateTags(['AppStatisticsConfirmed']));
    };
    const Component = wrapper || ActionButton;

    return (
        <ActionConfirmModal
            cancelText="Отмена"
            approveText="Очистить"
            modalTitle="Выполнить действие"
            confirmModalContent={DEFAULT_CLEAR_ELEMENT_CONFIRM_TEXT}
            confirmAction={handleClear}
        >
            {handleClick => (
                <Component
                    {...props}
                    onClick={handleClick}
                    actionIcon={meta.actionIcon}
                    disabled={!selectedRowKeys.length || (!initData?.length && isStatisticsConfirmed)}
                >
                    {meta.actionTitle}
                </Component>
            )}

        </ActionConfirmModal>
    );
};

export const ButtonActionForClearRows = ButtonActionForClearRowsComponent;
